const MapMarkerWithTooltipTheme = {
    mapMarkerWithTooltip: {
        light: {},
        dark: {},
    },
};
export default MapMarkerWithTooltipTheme;
